<div id="mainModal">
  <div class="modal-header">
    <h2 class="modal-title">
      <strong
        >{{
          (organizationEntities$ | async)[serieProposal.organizationId]
            ?.description
        }}
        ({{ (getSerieProposalItems$(serieProposal) | async)?.length }})
      </strong>
      -
      {{
        (serieProposal.linkedProductId
          | getTranslation : 'product' : 'description'
          | async) ||
          (productEntities$ | async)?.[serieProposal?.linkedProductId]
            ?.description
      }}
      <br />
      {{ 'general.day' + repeatableBooking.dayOfWeek | translate }}
      {{ repeatableBooking.startTime.slice(0, 5) }} -
      {{ repeatableBooking.endTime.slice(0, 5) }}
    </h2>
    <button
      type="button"
      class="btn-close"
      attr.aria-label="{{ 'general.close' | translate }}"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="form" #formRef="ngForm" [patchForm]="serieProposal">
      <!-- location -->
      <div class="row mb-4">
        <div class="col-12">
          <label class="form-label">
            {{ 'general.location' | translate }}
          </label>

          <product-select-input
            (search)="onSearchProducts($event)"
            [products]="locations$ | async"
            formControlName="locationId"
            [allowClearing]="false"
            class="flex-grow-1"
          ></product-select-input>
        </div>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.locationId.dirty && form.controls.locationId.invalid
          "
        >
          {{ 'productModule.resource' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="row mb-4">
        <div class="col-12">
          <label class="form-label">
            {{ 'productModule.resource' | translate }}
          </label>

          <div class="input-group">
            <product-select-input
              (search)="onSearchProducts($event)"
              [products]="resources$ | async"
              formControlName="productId"
              [allowClearing]="false"
              class="flex-grow-1"
            ></product-select-input>
          </div>

          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.productId.dirty && form.controls.productId.invalid
            "
          >
            {{ 'productModule.resource' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
      </div>

      <!-- day of the week -->
      <div class="row mb-4">
        <div class="col-12">
          <label class="form-label">
            {{ 'serieProposalModule.dayOfTheWeek' | translate }}
          </label>
          <div class="d-flex">
            <ng-container *ngFor="let day of daysOfWeek">
              <button
                class="btn btn-white rounded-circle avatar btn-sm"
                [ngClass]="{
                  'btn-primary': isDaySelected(day),
                  'btn-white': !isDaySelected(day)
                }"
                [disabled]="isDayDisabled(day)"
                type="button"
                (click)="form.controls['day'].setValue(day)"
                attr.aria-label="{{ 'general.day' + day | translate }}"
              >
                {{ 'general.dayAbbreviation' + day | translate }}
              </button>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- time inputs -->
      <div class="row mb-4">
        <fieldset class="col-6">
          <legend class="form-label"> {{ 'general.from' | translate }} </legend>
          <time-input
            formControlName="startTime"
            [minuteStep]="30"
          ></time-input>
        </fieldset>
        <fieldset class="col-6">
          <legend class="form-label">
            {{ 'serieProposalModule.till' | translate }}
          </legend>
          <time-input formControlName="endTime" [minuteStep]="30"></time-input>
        </fieldset>
      </div>

      <!-- resource -->
      <!-- <div class="row mb-4">
        <div class="col-12">
          <label class="form-label">
            {{ 'productModule.resource' | translate }}
          </label>
          <product-select-input
            formControlName="productId"
            (search)="onSearchProduct($event)"
            [products]="resources$ | async"
            [attr.aria-invalid]="form.controls['productId'].dirty &&
                form.controls['productId'].invalid ? 'true' : null"          ></product-select-input>
        </div>
      </div> -->

      <div class="mb-4">
        <fieldset>
          <legend class="inline-form-label">
            {{ 'general.sendEmailNotification' | translate }}
          </legend>
          <dms-switch
            [filterStyle]="false"
            [textItem1]="'general.yes'"
            [textItem2]="'general.no'"
            [responseItem1]="false"
            [responseItem2]="true"
            (onEmitItem1)="form.controls['dontSendMail'].patchValue($event)"
            (onEmitItem2)="form.controls['dontSendMail'].patchValue($event)"
            attr.aria-label=" {{ 'general.sendEmailNotification' | translate }}"
          >
          </dms-switch>
        </fieldset>
      </div>

      <div
        class="spinner-border"
        role="status"
        attr.aria-label="{{ 'general.loading' | translate }}"
        *ngIf="isLoading$ | async"
      >
      </div>

      <div
        *ngIf="!(isLoading$ | async)"
        class="d-flex mt-4"
        [ngClass]="{
          'justify-content-between':
            serieProposal?.id &&
            !(
              serieProposal?.status == serieProposalStatus.DECLINED ||
              serieProposal?.status == serieProposalStatus.ACCEPTED
            ),
          'justify-content-end':
            !serieProposal?.id ||
            serieProposal?.status == serieProposalStatus.DECLINED ||
            serieProposal?.status == serieProposalStatus.ACCEPTED
        }"
      >
        <button class="btn btn-soft-secondary" type="button" (click)="cancel()">
          {{ 'general.cancel' | translate }}
        </button>
        <button
          class="btn btn-primary"
          type="button"
          (click)="onClickSendCounterProposal()"
        >
          {{ 'serieProposalModule.makeCounterProposal' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
